export const VCStyles = {
    cardView : {
        container: "bg-iw-tileBackground grid grid-cols-[2.5fr_0.5fr] items-center shadow hover:shadow-lg hover:shadow-iw-selectedShadow p-4 m-2 rounded-md cursor-pointer",
        contentsContainer: "flex items-center gap-6 sm:gap-4 min-w-0 flex-1 overflow-hidden",
        logo: "w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0",
        credentialName:
            "text-sm font-semibold text-iw-title min-w-0 flex-1 break-words leading-snug",
        actionsContainer: "flex flex-row items-center flex-shrink-0",
        downloadIcon: "h-25 w-25",
        menuIcon: "m-1"
    }
}